import { CommonModule } from '@angular/common';
import { Component, ViewChild } from '@angular/core';
import { MaterialModule } from '../../../material.module';
import { Router, RouterModule } from '@angular/router';
import { TablerIconsModule } from 'angular-tabler-icons';
import { OnInit } from '@angular/core';
import { ReceiptsAndPaymentsApiService } from './receipts-and-payments-api.service';
import { ReceiptsAndPaymentsmodel } from '../../../Data/Models/ReceiptsandPayments/receipts-and-paymentsmodel';
import { MatTableDataSource } from '@angular/material/table';
import { CharityDataShareServiceService } from '../charities/services/charity-data-share-service.service';
import { CharitiesService } from '../charities/services/charities.service';
import { RolesModel } from '../../../Data/Models/Users/roles-model';
import { UsermanagementService } from '../../../services/apps/usermanagement/usermanagement.service';
import { MatDialog } from '@angular/material/dialog';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatRadioModule } from '@angular/material/radio';
import { Editor, NgxEditorComponent, Toolbar, NgxEditorMenuComponent } from 'ngx-editor';
import { BaseEntityModel } from '../../../Data/Models/Common/base-entity-model';
import { Email_Configuration_Model } from '../../../Data/Models/Email_Configuration_Model/Email_Configuration_Model';
import Swal from 'sweetalert2';
import { HttpErrorResponse } from '@angular/common/http';
import { Email_Configuration_Service } from '../../../services/Email_Configuration_Service/Email_Configuration_Service';
import { BalanceSheetapiService } from '../balancesheet/balance-sheetapi.service';
import { NotesDatashareService } from '../notes/services/notes-datashare.service';
import { ReportsService } from '../reports/reports.service';
import { PdfJsViewerComponent, PdfJsViewerModule } from 'ng2-pdfjs-viewer';
import { MessageServiceService } from '../../../Shared/common/message-service.service';

@Component({
  selector: 'app-receiptsand-payments',
  imports: [CommonModule, MaterialModule, RouterModule, TablerIconsModule, CommonModule, FormsModule, ReactiveFormsModule, MatRadioModule, NgxEditorComponent, NgxEditorMenuComponent, PdfJsViewerModule],
  templateUrl: './receiptsand-payments.component.html',
  styleUrl: './receiptsand-payments.component.scss'
})
export class ReceiptsandPaymentsComponent implements OnInit {
  AccountingPeriod: any;
    isFundTracking: any;
  firstAccPeriod: any;
    RetriveEmailConfigdata: any;
    pdfFile: string;
  Downloadreportname: string;
  ShowSpinner: any = false;
  ispreview: boolean = false
  apFinalised: boolean = false;
  SubmissionStatus: any;

  disablePreview: boolean = false;
  @ViewChild('pdfViewerAutoLoad', { static: false }) pdfViewerAutoLoad: PdfJsViewerComponent
    CurrentUserName: string;

  constructor(public dialog: MatDialog, private RPservice: ReceiptsAndPaymentsApiService, private Charities_Service: CharitiesService, private reportservice: ReportsService, private router: Router, private datashare: NotesDatashareService, private fb: FormBuilder, private emailConfigService: Email_Configuration_Service, private apiservice: BalanceSheetapiService,
    private sharedService: CharityDataShareServiceService, private _UsermanagementService: UsermanagementService, private msgService: MessageServiceService,) {
    this.GetUserAccess()
    var parsedUser1: any = localStorage.getItem('currentUser');
    const parsedUser = JSON.parse(parsedUser1);
    this.CurrentUserName = `${parsedUser.firstName} ${parsedUser.lastName}`;
  }
  editor1: Editor;
  displayedColumns2: string[] = ['account_Name', 'Unrestrictedfunds', 'Restricted income funds (£)', 'Endowment funds (£)', 'Total funds (£)', 'Prior year funds (£)'];
  ColumnsWithoutFundTracking: string[] = ['account_Name','Total funds (£)', 'Prior year funds (£)'];
  transactions: MatTableDataSource<ReceiptsAndPaymentsmodel>;
  isdirty: any = false;
  ngOnInit() {
    debugger
    this.sharedService.finalStatus$.subscribe((value: any) => {
      this.apFinalised = value != '' && value == 'Completed'
    })
    this.SubmissionStatus = localStorage.getItem('SubmissionStatus');
    this.datashare.isdirty$.subscribe(value => {
      this.isdirty = value
    })
    this.editor1 = new Editor();
    this.Getbasicinformation()
    this.createReceipts_PaymentsTemplate()
    //this.GetReceiptAndPaymentsTemplate();
  }

  UserRoleAccess: RolesModel;
  GetUserAccess() {
    this._UsermanagementService.GetUserRoleAccess(localStorage['userID']).subscribe(data => {
      if (data.entity.length) {
        this.UserRoleAccess = data.entity[0]
        var submitedDate = this.UserRoleAccess.currentAPSubmitDate
      }
    });
  }

  toolbar: Toolbar = [
    ['bold', 'italic'],
    ['underline'],
    ['ordered_list', 'bullet_list'],
    [{ heading: ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'] }],
    ['text_color', 'background_color'],
    ['align_left', 'align_center', 'align_right', 'align_justify'],
  ];

  Receipts_Paymentsform: FormGroup
  createReceipts_PaymentsTemplate() {
    this.Receipts_Paymentsform = this.fb.group({
      emailTemplateId: [0],
      emailType: ['Receipts_Payments'],
      from: [{ value: this.RetriveEmailConfigdata?.senderEmail, disabled: true }],
      //cc: ['', [Validators.pattern(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/)]],
      //bcc: ['', [Validators.pattern(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/)]],

      //pattern to allow multiple emails.
      cc: ['', [Validators.pattern(/^([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[A-Za-z]{2,})(;\s*[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[A-Za-z]{2,})*$/)]],
      bcc: ['', [Validators.pattern(/^([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[A-Za-z]{2,})(;\s*[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[A-Za-z]{2,})*$/)]],
      ccCheckbox: [false],
      subject: ['', Validators.required],
      Body: [''],
      charityName: [''],
      charityID: [+localStorage.getItem('charityId')!],
      financialPeriodsID: [+localStorage.getItem('currentPeriod')!],
      createdby: [0],
      modifiedby: [0],
      centralUserId: [+localStorage.getItem('CentralUserId')!],
      userId: [+localStorage.getItem('CurrentuserID')!],
      fund_Tracking: [localStorage.getItem('fund_Tracking') === 'true'],
      //fund_Tracking:[+localStorage.getItem('fund_Tracking')!],
      to: [
        '',
        [Validators.required, Validators.pattern(/^([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[A-Za-z]{2,})(;\s*[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[A-Za-z]{2,})*$/)]
      ],
    });
    this.ifCCorBCCReceipts_Payments = false
    this.Receipts_Paymentsform.get('Body')?.valueChanges.subscribe(value => {

      const plainText = value?.replace(/<[^>]*>/g, '') || '';
      if (plainText.length > 2500) {
        const trimmedText = plainText.substring(0, 2500);
        const safeHtml = `<p>${trimmedText}</p>`;
        this.Receipts_Paymentsform.get('Body')?.setValue(safeHtml, { emitEvent: false });
      }
    });

  }

  sendMailTemplate(emailtemplate: any) {
    this.RetriveEmailConfig(emailtemplate)
    //this.dialog.open(emailtemplate, {
    //  width: '50%', maxWidth: '100%', maxHeight: 'auto', height: 'auto', disableClose: false
    //});
  }
  cenceltemplate() {
    debugger
    if (this.Receipts_Paymentsform.dirty) {
      Swal.fire({
        html: '<h5 class="f-s-16 f-w-600 text-black" id="exampleModalLiveLabel">Leave the page?</h5> <p class= "f-s-14 p-0 m-y-5 f-w-400 text-black"  style="line-height:22px"> Are you sure you want to leave this page. <br> Data entered will not be saved.</p>',
        iconHtml: '<span class="fa fa-exclamation rounded-icon"></span>',
        confirmButtonText: "Leave",
        showCancelButton: true,
        cancelButtonText: "Stay",
        allowOutsideClick: false,
        reverseButtons: true
      }).then((result) => {
        if (result.isConfirmed) {
          debugger
          this.datashare.setisdirty(false)
          this.isdirty = false
          this.Receipts_Paymentsform.markAsUntouched()
          this.Receipts_Paymentsform.markAsPristine()
          this.Receipts_Paymentsform.controls['to'].markAsUntouched()
          this.dialog.closeAll()
        }
        else {
          localStorage.setItem("currentCharityIDFromSwitch", "");
          return
        }

      })

    }
    else {
      this.Receipts_Paymentsform.markAsUntouched()
      this.Receipts_Paymentsform.markAsPristine()
      this.Receipts_Paymentsform.controls['to'].markAsUntouched()
      this.dialog.closeAll()

    }

  }

  sendmail() {
    debugger
    if (this.Receipts_Paymentsform.valid) {
      this.apiservice.sentmail(this.Receipts_Paymentsform.getRawValue()).subscribe((Data: any) => {
        debugger
        var reponse = Data;
        if (reponse == "TrialBalanceEmailResponse") {
          Swal.fire({
            html: '<h5 class="f-s-16 f-w-600 text-black" id="exampleModalLiveLabel">Mail Server details not configured!</h5> <p class= "f-s-14 p-0 m-y-5 f-w-400 text-black"  style="line-height:22px"> Please configure Mail Server setting to send an email.',
            iconHtml: '<span class="fa fa-exclamation rounded-icon"></span>',
            confirmButtonText: "OK",

            allowOutsideClick: false
          }).then((result) => {
            if (result.value) {
            } else {
              return
            }
          })
        }
        else if (reponse == "TrialBalanceTemplateresponse") {
          Swal.fire({
            html: '<h5 class="f-s-16 f-w-600 text-black" id="exampleModalLiveLabel">Please complete the Preference</h5> <p class= "f-s-14 p-0 m-y-5 f-w-400 text-black"  style="line-height:22px"> Preference need to be done.',
            iconHtml: '<span class="fa fa-exclamation rounded-icon"></span>',
            confirmButtonText: "Ok",
            allowOutsideClick: false
          }).then((result) => {
            if (result.value) {
            } else {
              return
            }
          })
        } else if (reponse == "mail_sent") {
          debugger
          this.dialog.closeAll()
          this.msgService.showToastMessage("success", "Mail sent successfully");
        }
      })
    } else {


      this.Receipts_Paymentsform.markAllAsTouched()
    }
  }


  RetriveEmailConfig(emailtemplate?: any) {
    debugger
    var Central_UserId = parseInt(localStorage.getItem('CentralUserId') || '0');
    this.emailConfigService.RetriveEmailConfig(Central_UserId).subscribe((data: BaseEntityModel<Email_Configuration_Model>) => {
      if (data.status === 0) {
        if (data.message == "Successfully, retrieved email server info") {
          if (data.entity != null && data.entity.length > 0) {
            this.RetriveEmailConfigdata = data.entity[0];
            this.Receipts_Paymentsform.controls['from'].setValue(this.RetriveEmailConfigdata?.senderEmail)
            this.Receipts_Paymentsform.controls['to'].markAsUntouched()
            this.dialog.open(emailtemplate, {
              width: '50%', maxWidth: '100%', maxHeight: 'auto', height: 'auto', disableClose: true
            });
            this.GetEmailTemplate()
          } else {
            Swal.fire({
              html: '<h5 class="f-s-16 f-w-600 text-black" id="exampleModalLiveLabel">Mail Server details not configured!</h5> <p class= "f-s-14 p-0 m-y-5 f-w-400 text-black"  style="line-height:22px"> Please configure Mail Server setting to send an email.',
              iconHtml: '<span class="fa fa-exclamation rounded-icon"></span>',
              confirmButtonText: "OK",
              allowOutsideClick: false
            }).then((result) => {
              if (result.value) {
              } else {
                return
              }
            })
            //this.toastr.error(data.message);

          }
        } else {
        }
      } else {
        Swal.fire({
          html: '<h5 class="f-s-16 f-w-600 text-black" id="exampleModalLiveLabel">Mail Server details not configured!</h5> <p class= "f-s-14 p-0 m-y-5 f-w-400 text-black"  style="line-height:22px"> Please configure Mail Server setting to send an email.',
          iconHtml: '<span class="fa fa-exclamation rounded-icon"></span>',
          confirmButtonText: "OK",
          allowOutsideClick: false
        }).then((result) => {
          if (result.value) {
          } else {
            return
          }
        })
        //t//his.toastr.error(data.message);
      }
    }, (error: HttpErrorResponse) => {
      //this.toastr.error(error.statusText);
    })

  }
  isBodyEmpty(formname?: any): boolean {
    const rawHtml = formname.get('Body')?.value || '';
    const strippedText = rawHtml.replace(/<[^>]*>/g, '').trim();
    return strippedText === '';
  }
  ifCCorBCCReceipts_Payments: boolean = false;

  Receipts_PaymentsformmailtoCC() {
    debugger
    this.ifCCorBCCReceipts_Payments = !this.ifCCorBCCReceipts_Payments;
    if (!this.ifCCorBCCReceipts_Payments) {
      this.Receipts_Paymentsform.controls['cc'].reset();
      this.Receipts_Paymentsform.controls['bcc'].reset();
    }
  }
  GetEmailTemplate() {
    debugger;
    this.Charities_Service.GetEmailTemplate(this.Receipts_Paymentsform.controls['centralUserId'].value, this.Receipts_Paymentsform.controls['emailType'].value).subscribe({
      next: (data: any) => {
        debugger;
        if (data.entity != null && data.entity[0].emailTemplateId != null) {
          data.entity[0].body = data.entity[0].body.replace('[UserName]', this.CurrentUserName)

          data.entity[0].subject = data.entity[0].subject.replace('[CharityName]', localStorage.getItem('charity_Name'))
          data.entity[0].subject = data.entity[0].subject.replace('[CN]', localStorage.getItem('charity_Registration_Number'))
          data.entity[0].charityName = localStorage.getItem('charity_Name')
          data.entity[0].body = data.entity[0].body.replace('[CharityName]', localStorage.getItem('charity_Name'))
          data.entity[0].body = data.entity[0].body.replace('[CN]', localStorage.getItem('charity_Registration_Number'))
          this.Receipts_Paymentsform.patchValue(data.entity[0])
          this.Receipts_Paymentsform.controls['Body'].setValue(data.entity[0].body)
          this.Receipts_Paymentsform.controls['charityID'].setValue(+localStorage.getItem('charityId')!)
          this.Receipts_Paymentsform.controls['financialPeriodsID'].setValue(+localStorage.getItem('currentPeriod')!)
          this.Receipts_Paymentsform.controls['fund_Tracking'].setValue(localStorage.getItem('fund_Tracking') === 'true')
          this.ifCCorBCCReceipts_Payments = data.entity[0].ccCheckbox;
        }
        else {
          this.createReceipts_PaymentsTemplate()
        }
        this.Receipts_Paymentsform.controls['from'].setValue(this.RetriveEmailConfigdata?.senderEmail)
        this.Receipts_Paymentsform.markAsPristine()
      },
      error: (err) => {
        console.error('Error fetching GetEmailTemplate details:', err);
      }
    });
  }

  GetReceiptAndPaymentsTemplate() {
    debugger
    this.ShowSpinner=true
    this.sharedService.FY_Year$.subscribe(value => {
      let date = value.split('*')[0];
      this.AccountingPeriod = value.split('*')[1];
    });
    var CurrentAccpId = localStorage.getItem('currentPeriod')
    this.RPservice.GetReceiptsAndPayments(CurrentAccpId).subscribe((data: any) => {
      debugger
      this.transactions = data.entity
      //his.ispreview = data.entity[0].ispreview == 'false';
      this.ShowSpinner=false
    })
  }
  SaveReceiptsandPayments() {
    debugger
    this.router.navigate(['/assets-statements'])
  }
  Back() {
    this.router.navigate(['/trialbalance'])
  }

  Getbasicinformation() {
    debugger
    const period = localStorage.getItem('currentPeriod');
    const charityId = localStorage.getItem('currentCharityID');

    this.Charities_Service.Getbasicinfo(charityId, period).subscribe((data: any) => {
      debugger
      this.isFundTracking = data[0].fund_Tracking
      this.DynamicColumns();
      this.ispreview = data[0].istrialbalanceaSaved==1?true:false
      this.GetReceiptAndPaymentsTemplate();
    })
  }

  DynamicColumns() {
    debugger
    this.firstAccPeriod = localStorage.getItem('IsFirstAccountingPeriod')
    if (this.isFundTracking == false) {
      if (this.firstAccPeriod == 'true') {
        this.ColumnsWithoutFundTracking = ['account_Name', 'Total funds (£)', 'Prior year funds (£)'];
      } else {
        this.ColumnsWithoutFundTracking = ['account_Name', 'Total funds (£)'];
      }
    } else {
      if (this.firstAccPeriod == 'true') {
        this.displayedColumns2 = ['account_Name', 'Unrestrictedfunds', 'Restricted income funds (£)', 'Endowment funds (£)', 'Total funds (£)', 'Prior year funds (£)'];
      } else {
        this.displayedColumns2 = ['account_Name', 'Unrestrictedfunds', 'Restricted income funds (£)', 'Endowment funds (£)', 'Total funds (£)'];
      }
    }
  }
  //transactions2: any[] = [
  //  { type: 'header', headersName: ' A1 Receipts' },
  //  { account_Name: 'Donations and gifts', Unrestrictedfunds: 10, restrictedfunds: 20, end: 30, total: '£ 100.00', pyf: 45, type: 'data' },
  //  { account_Name: 'Gift Aid', Unrestrictedfunds: 10, restrictedfunds: 20, end: 30, total: '£0.00', pyf: 45, type: 'data' },
  //  { account_Name: 'Legacies', Unrestrictedfunds: 10, restrictedfunds: 20, end: 30, total: '£0.00', pyf: 45, type: 'data' },
  //  { account_Name: 'General grants provided by government/other charities', Unrestrictedfunds: 10, restrictedfunds: 20, end: 30, total: '£0.00', pyf: 45, type: 'data' },
  //  { account_Name: 'Membership subscriptions and sponsorships which are in substance donations', Unrestrictedfunds: 10, restrictedfunds: 20, end: 30, total: '£0.00', pyf: 45, type: 'data' },
  //  { account_Name: 'Donated goods, facilities and services', Unrestrictedfunds: 10, restrictedfunds: 20, end: 30, total: '£0.00', pyf: 45, type: 'data' },
  //  { account_Name: 'Charitable activities', Unrestrictedfunds: 10, restrictedfunds: 20, end: 30, total: '£0.00', pyf: 45, type: 'data' },
  //  { account_Name: 'Other trading activities', Unrestrictedfunds: 10, restrictedfunds: 20, end: 30, total: '£0.00', pyf: 45, type: 'data' },
  //  { account_Name: 'Interest income', Unrestrictedfunds: 10, restrictedfunds: 20, end: 30, total: '£0.00', pyf: 45, type: 'data' },
  //  { account_Name: 'Dividend income', Unrestrictedfunds: 10, restrictedfunds: 20, end: 30, total: '£0.00', pyf: 45, type: 'data' },
  //  { account_Name: 'Separate material account_Name of income', Unrestrictedfunds: 10, restrictedfunds: 20, end: 30, total: '£0.00', pyf: 45, type: 'data' },
  //  { account_Name: 'Rental and leasing income', Unrestrictedfunds: 10, restrictedfunds: 20, end: 30, total: '£0.00', pyf: 45, type: 'data' },
  //  { account_Name: 'Other', Unrestrictedfunds: 10, restrictedfunds: 20, end: 30, total: '£0.00', pyf: 45, type: 'data' },
  //  { account_Name: 'Sub total (Gross income for AR)', Unrestrictedfunds: '100.00', restrictedfunds: '0.00', end: '0.00', total: '0.00', pyf: '100.00', type: 'footer' },
  //  { type: 'header', headersName: 'A2 Asset and investment sales' },
  //  { account_Name: ' Asset and investment sales', Unrestrictedfunds: 10, restrictedfunds: 20, end: 30, total: '£0.00', pyf: 45, type: 'data' },
  //  { account_Name: 'Sub total (Gross income for AR)', Unrestrictedfunds: '£100.00', restrictedfunds: '£0.00', end: '£0.00', total: '£0.00', pyf: '£100.00', type: 'footer' },
  //  { account_Name: 'Total receipts', Unrestrictedfunds: '£100.00', restrictedfunds: '£0.00', end: '£0.00', total: '£0.00', pyf: '£100.00', type: 'footer' },
  //  { type: 'header', headersName: 'A3 Payments' },
  //  { account_Name: 'Charitable activities', Unrestrictedfunds: 10, restrictedfunds: 20, end: 30, total: '£0.00', pyf: 45, type: 'data' },
  //  { account_Name: 'Fundraising costs', Unrestrictedfunds: 10, restrictedfunds: 20, end: 30, total: '£0.00', pyf: 45, type: 'data' },
  //  { account_Name: 'Support costs', Unrestrictedfunds: 10, restrictedfunds: 20, end: 30, total: '£0.00', pyf: 45, type: 'data' },
  //  { account_Name: 'Governance costs', Unrestrictedfunds: 10, restrictedfunds: 20, end: 30, total: '£0.00', pyf: 45, type: 'data' },
  //  { account_Name: 'Other expenditure', Unrestrictedfunds: 10, restrictedfunds: 20, end: 30, total: '£0.00', pyf: 45, type: 'data' },
  //  { account_Name: 'Sub total (Gross income for AR)', Unrestrictedfunds: '£100.00', restrictedfunds: '£0.00', end: '£0.00', total: '£0.00', pyf: '£100.00', type: 'footer' },
  //  { type: 'header', headersName: 'A4 Asset and investment purchases' },
  //  { account_Name: ' Asset and investment purchases', Unrestrictedfunds: 10, restrictedfunds: 20, end: 30, total: '£0.00', pyf: 45, type: 'data' },
  //  { account_Name: 'Sub total	', Unrestrictedfunds: '£100.00', restrictedfunds: '£0.00', end: '£0.00', total: '£0.00', pyf: '£100.00', type: 'footer' },
  //  { account_Name: 'Total payments	', Unrestrictedfunds: '', restrictedfunds: '', end: '', total: '£0.00', pyf: '', type: 'footer' },
  //  { account_Name: 'Net of receipts/(payments)	', Unrestrictedfunds: '0.00', restrictedfunds: '', end: '', total: '£0.00', pyf: '', type: 'footer' },
  //  { account_Name: 'A5 Transfers between funds', Unrestrictedfunds: 10, restrictedfunds: 20, end: 30, total: '£0.00', pyf: 45, type: 'data' },
  //  { account_Name: 'A6 Cash funds last year end', Unrestrictedfunds: 10, restrictedfunds: 20, end: 30, total: '£0.00', pyf: 45, type: 'data' },
  //  { account_Name: 'Cash funds this year end	', Unrestrictedfunds: '0.00', restrictedfunds: '', end: '0.00', total: '£0.00', pyf: '0.00', type: 'footer' },
  //];

  isDataRow = (index: number, row: any) => row.dataType === 'Data';
  isHeaderRow = (index: number, row: any) => row.dataType === 'Header';
  isfooterrow = (index: number, row: any) => row.dataType === 'Footer';
  backToCharityOverView() {
    localStorage.setItem('isFromBasicInfo', 'true')
    this.router.navigate(['/charity']);
  }

  Preview(template: any) {
    debugger
    this.ShowSpinner=true
    this.reportservice.Receipts_PaymentsReport(+localStorage.getItem('currentPeriod')!, localStorage.getItem('IsFirstAccountingPeriod'), localStorage.getItem('fund_Tracking') == 'true' ? true : false).subscribe((data: any) => {
      const byteCharacters = atob(data.Item1.toString());
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], { type: 'application/pdf' });
      this.pdfFile = URL.createObjectURL(blob);

      this.Downloadreportname = "Cash (Receipts and Payments) Report";
      this.dialog.open(template, {
        width: '50%', maxWidth: '100%', maxHeight: 'auto', height: 'auto', disableClose: true
      });
      setTimeout(() => {
        if (this.pdfViewerAutoLoad) {
        
          this.pdfViewerAutoLoad.pdfSrc = this.pdfFile;
          this.pdfViewerAutoLoad.downloadFileName = this.Downloadreportname;
          this.pdfViewerAutoLoad.page = 1;
          this.pdfViewerAutoLoad.refresh();
          this.ShowSpinner = false
        }
      }, 1000)
     // this.ShowSpinner = false
    })
  }

  UnlockandAmend() {
    debugger
    var fid: any = localStorage.getItem('currentPeriod') ? localStorage.getItem('currentPeriod') : 0
    if (this.UserRoleAccess.m1Amend) {
      Swal.fire({
        html: `<h5 class="f-s-16 f-w-600 text-black" id="exampleModalLiveLabel">Are you sure?</h5> <p class= "f-s-14 p-0 m-y-5 f-w-400 text-black" style="line-height:22px; padding-right: 30px !important;"> Unlocking the accounting period will allow you to amend the filed accounts and correct any errors. After making any changes, the accounts must be submitted again as an Amended filing. Do you want to unlock and amend the accounting period?</p>`,
        iconHtml: '<span class="fa fa-exclamation rounded-icon"></span>',
        confirmButtonText: "Yes",
        showCancelButton: true,
        cancelButtonText: "No",
        allowOutsideClick: false,
        reverseButtons: true
      }).then((result) => {
        if (result.value) {
          this._UsermanagementService.UnfreezeAP(+fid).subscribe((data: any) => {
            debugger
            this.sharedService.setFinalStatus('InCompleted');
            localStorage.setItem('apFinalised', 'InCompleted')
          })
          //this.save("FinaliseandClose");
        }
        else { }
      })
    }
    else {
      Swal.fire({
        html: '<p class= "f-s-14 p-0 m-y-5 f-w-400 text-black" style="line-height:22px"><b>Access Denied</b> <br/> You do not have the required permissions to perform this action</p>',
        iconHtml: '<span class="fa fa-warning"></span>',
        confirmButtonText: "OK",
        allowOutsideClick: false
      })
    }
  }
  UnfreezeAP() {
    debugger
    var fid: any = localStorage.getItem('currentPeriod') ? localStorage.getItem('currentPeriod') : 0
    if (this.UserRoleAccess.m1Submit) {
      Swal.fire({
        html: `<h5 class="f-s-16 f-w-600 text-black" id="exampleModalLiveLabel">Are you sure?</h5> <p class= "f-s-14 p-0 m-y-5 f-w-400 text-black" style="line-height:22px; padding-right: 30px !important;"> Do you want to unlock the Accounting Period? </p>`,
        iconHtml: '<span class="fa fa-exclamation rounded-icon"></span>',
        confirmButtonText: "Yes",
        showCancelButton: true,
        cancelButtonText: "No",
        allowOutsideClick: false,
        reverseButtons: true
      }).then((result) => {
        if (result.value) {
          this._UsermanagementService.UnfreezeAP(+fid).subscribe((data: any) => {
            debugger
            const message = "Accounting Period unlocked successfully";
            this.msgService.showToastMessage('success', message)
            this.sharedService.setFinalStatus('InCompleted');
            localStorage.setItem('apFinalised', 'InCompleted')
          })
        }
      })
    } else {
      Swal.fire({
        html: '<p class= "f-s-14 p-0 m-y-5 f-w-400 text-black"  style="line-height:22px"> <b>Access Denied</b> <br/> You do not have the required permissions to perform this action</p>',
        iconHtml: '<span class="fa fa-warning"></span>',
        confirmButtonText: "OK",
        allowOutsideClick: false
      })
    }
  }
  gotoSubmissions() {
    var fid: any = localStorage.getItem('currentPeriod') ? localStorage.getItem('currentPeriod') : 0
    if (this.UserRoleAccess.m1Submit) {
      this._UsermanagementService.GoToSubmissions()
    } else {
      Swal.fire({
        html: '<p class= "f-s-14 p-0 m-y-5 f-w-400 text-black"  style="line-height:22px"> <b>Access Denied</b> <br/> You do not have the required permissions to perform this action</p>',
        iconHtml: '<span class="fa fa-warning"></span>',
        confirmButtonText: "OK",
        allowOutsideClick: false
      })
    }

  }


}

